import { apiClient } from './client';

export type MermaReason =
  | 'CLIMA'
  | 'PLAGA'
  | 'MECANICO'
  | 'RECHAZO_CALIDAD'
  | 'PUDRICION'
  | 'OTRO';

export interface MermaRecord {
  mermaId:          string;
  loteId:           string;
  moduleId?:        string;
  batchId:          string;
  reason:           MermaReason;
  rejectedKg:       number;
  rejectedBoxes?:   number;
  etiquetaId?:      string;
  packagingLogId?:  string;
  costPerKg?:       number;
  wasteImpactCost?: number;
  evidenceUrls:     string[];
  notes?:           string;
  status:           'REGISTRADA' | 'VERIFICADA' | 'CERRADA';
  reportedBy:       string;
  registeredAt:     string;
}

export interface MermaWasteKpi {
  loteId:               string;
  batchId?:             string;
  totalRejectedKg:      number;
  totalWasteImpactCost: number;
  rejectedByReason:     Partial<Record<MermaReason, number>>;
  recordCount:          number;
}

export interface MermaSummaryResponse {
  records: MermaRecord[];
  kpi:     MermaWasteKpi;
}

/** Registros de merma de un lote */
export const fetchMermaByLote = async (loteId: string, moduleId?: string): Promise<MermaRecord[]> =>
  (await apiClient.get(`/api/lotes/${loteId}/merma`, { params: moduleId ? { moduleId } : undefined })).data;

/** KPIs de merma de un lote (opcionalmente filtrado por ciclo) */
export const fetchMermaKpi = async (loteId: string, batchId?: string, moduleId?: string): Promise<MermaWasteKpi> => {
  const params = { ...(batchId ? { batchId } : {}), ...(moduleId ? { moduleId } : {}) };
  return (await apiClient.get(`/api/lotes/${loteId}/merma/kpi`, { params })).data;
};

/** Resumen global de merma para la página de cosecha */
export const fetchMermaSummary = async (ranchoId?: string | null, moduleId?: string): Promise<MermaSummaryResponse> =>
  (await apiClient.get('/api/merma/summary', { params: ranchoId || moduleId ? { ...(ranchoId ? { ranchoId } : {}), ...(moduleId ? { moduleId } : {}) } : undefined })).data;

// ── Mutaciones (dashboard manual) ────────────────────────────────────────────

export interface CreateMermaInput {
  batchId:       string;
  /** Zona o subzona donde ocurrió la merma (opcional). */
  moduleId?:     string;
  reason:        MermaReason;
  rejectedKg:    number;
  rejectedBoxes?: number;
  notes?:        string;
  costPerKg?:    number;
}

/** Registrar un nuevo registro de merma desde el dashboard */
export const createMermaRecord = async (
  loteId: string,
  input: CreateMermaInput
): Promise<MermaRecord> =>
  (await apiClient.post(`/api/lotes/${loteId}/merma`, input)).data;

/** Cerrar el reporte de merma de un ciclo (marca todos como CERRADA) */
export const closeMermaReport = async (
  loteId: string,
  batchId: string
): Promise<{ closedCount: number }> =>
  (await apiClient.post(`/api/lotes/${loteId}/merma/close`, { batchId })).data;
